import { SearchIcon } from "@/Icons/v2/Search";
import { useTrans } from "@/translations";

import { useCallback, useContext } from "react";

import { LibraryPageContext } from "../context";
import { FileStatus } from "../types";

export const SearchBar: React.FC = () => {
  const { t } = useTrans();
  const {
    searchValue,
    setSearchValue,
    setSelectedFolderName,
    setSelectedViewId,
  } = useContext(LibraryPageContext);

  const onValueChange = useCallback(
    (value: string) => {
      setSearchValue(value);

      if (!value.trim().length) {
        setSelectedViewId(FileStatus.PUBLISHED);
        setSelectedFolderName("");
      } else {
        setSelectedViewId(null);
        setSelectedFolderName("");
      }
    },
    [setSearchValue, setSelectedFolderName, setSelectedViewId],
  );

  return (
    <div className="relative max-w-[340px] min-w-[220px] flex-1 bg-white">
      <span className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-[#9a958f]">
        <SearchIcon />
      </span>
      <input
        value={searchValue}
        onChange={(e) => onValueChange(e.target.value)}
        placeholder={t("libraryPage:filesSearchPlaceholder")}
        className="border-grey3 w-full rounded border py-[10px] pr-3 pl-9 text-[14px] outline-none"
      />
    </div>
  );
};
